import React, { Component, PropTypes } from 'react';

import _ from 'lodash';
import moment from 'moment';
import { getStates } from '../../../../utils/topography.js';
import { Field, reduxForm } from 'redux-form';
import { renderFormTextField } from '../../../../utils/forms/FormFieldValidatonWrapper';
import { newDriverFormvalidate } from '../validators';

import {
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MANDATORY,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_FIRST_NAME,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_LAST_NAME,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_LICENSE_NO,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_ISSUING_STATE,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_EMAIL_ID,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MOBILE_NO,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_PAYROLL_NO,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_BUSINESS_ADDRESS,
} from '../content';

import {
  NitroParagraph,
  NitroSingleSelect,
  NitroDatePicker,
  NitroPlaceholder,
} from 'nitro-components';

import styled from 'styled-components';

const InputRow = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const InputRowHalf = styled.div`
  width: 48%;
`;

const validate = (values, props) => {
  return newDriverFormvalidate(values, props.country);
};

//Refer any further component validations - https://github.com/erikras/redux-form/issues/542

class NewDriverTab extends Component {
  setAllocationDate = date => {
    this.props.setDriverDetails({
      target: { name: 'newDriverAllocationDate', value: date },
    });
  };

  setIssuingState = option => {
    this.props.setDriverDetails({
      target: { name: 'newDriverIssuingState', value: option.value },
    });
  };

  render() {
    const { handleSubmit, country } = this.props;
    const minDate = moment()
      .subtract(1, 'month')
      .toDate();

    const {
      newDriverFirstName,
      newDriverSurName,
      newDriverLicenceNo,
      newDriverIssuingState,
      newDriverEmailID,
      newDriverMobileNo,
      newDriverPayrollNo,
      newDriverBusinessMailingAddress,
      newDriverAllocationDate,
    } = this.props.driverDetails;

    const { setDriverDetails } = this.props;
    const driverIssuingState =
      country.value === 'NZ' ? 'NZ' : newDriverIssuingState;

    return (
      <form onSubmit={handleSubmit} autoComplete="off">
        <NitroPlaceholder size={40} />
        <NitroParagraph size="4" variant="base3">
          {ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MANDATORY}
        </NitroParagraph>

        <InputRow>
          <Field
            name="newDriverFirstName"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_FIRST_NAME
            }
            value={newDriverFirstName}
            onChange={setDriverDetails}
            fullWidth
          />
        </InputRow>

        <InputRow>
          <Field
            name="newDriverSurName"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_LAST_NAME
            }
            value={newDriverSurName}
            onChange={setDriverDetails}
            fullWidth
          />
        </InputRow>

        <InputRow>
          <Field
            name="newDriverMobileNo"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MOBILE_NO
            }
            value={newDriverMobileNo}
            onChange={setDriverDetails}
            fullWidth
          />
        </InputRow>

        <InputRow>
          <Field
            name="newDriverEmailID"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_EMAIL_ID
            }
            value={newDriverEmailID}
            onChange={setDriverDetails}
            fullWidth
          />
        </InputRow>

        <InputRow>
          <Field
            name="newDriverPayrollNo"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_PAYROLL_NO
            }
            value={newDriverPayrollNo}
            onChange={setDriverDetails}
            fullWidth
          />
        </InputRow>

        <InputRow>
          <Field
            name="newDriverBusinessMailingAddress"
            component={renderFormTextField}
            floatingLabelText={
              ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_BUSINESS_ADDRESS
            }
            value={newDriverBusinessMailingAddress}
            onChange={setDriverDetails}
            fullWidth
            props={{
              customprops: {
                rows: 3,
                multiLine: true,
              },
            }}
          />
        </InputRow>

        <NitroPlaceholder size={10} />

        <NitroDatePicker
          placeholder={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE}
          value={newDriverAllocationDate}
          onChange={this.setAllocationDate}
          // shouldDisableDate={this.disableDate}
          minDate={minDate}
        />

        <NitroPlaceholder size={100} />
      </form>
    );
  }
}

NewDriverTab.propTypes = {
  country: PropTypes.object.isRequired,
  driverDetails: PropTypes.object,
  setDriverDetails: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'NewDriverTab', // a unique identifier for this form
  validate,
})(NewDriverTab);



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/NewDriverTab.js